document.addEventListener('click', function (e) {
  var wrapper = e.target.closest('.wrapper');
  if (!wrapper) return;

  // Tabs principales: INTERNATIONAL SIZING / SIZING
  var mainBtn = e.target.closest('.tab-nav > .tab-btn');
  if (mainBtn) {
    var targetId = mainBtn.getAttribute('data-target');
    var targetPanel = wrapper.querySelector('#' + targetId);

    wrapper.querySelectorAll('.tab-nav > .tab-btn').forEach(function (b) {
      b.classList.remove('active');
    });
    wrapper.querySelectorAll('.tabs-outer > .tab-contentsss').forEach(function (p) {
      p.classList.remove('active');
    });

    mainBtn.classList.add('active');
    if (targetPanel) targetPanel.classList.add('active');
    return;
  }

  // Tabs internos: CM / IN
  var innerBtn = e.target.closest('.inner-nav > .inner-btn');
  if (innerBtn) {
    var innerTargetId = innerBtn.getAttribute('data-target');
    var innerNav = innerBtn.closest('.inner-nav');
    var tabsInner = innerBtn.closest('.tabs-inner');
    var innerTargetPanel = tabsInner.querySelector('#' + innerTargetId);

    innerNav.querySelectorAll('.inner-btn').forEach(function (b) {
      b.classList.remove('active');
    });
    tabsInner.querySelectorAll('.inner-contentsss').forEach(function (p) {
      p.classList.remove('active');
    });

    innerBtn.classList.add('active');
    if (innerTargetPanel) innerTargetPanel.classList.add('active');
  }
});